import { request, METHOD, removeAuthorization } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/**
 * #10060  用户管理列表
 *   GET /sys/user
 *   接口ID：216079102
 *   接口地址：https://app.apifox.com/link/project/3032888/apis/api-216079102
 * @return {Promise<AxiosResponse<T>>}
 */
export function getAdminList(data) {
  return request("".concat(BASE_URL) + "/sys/user", METHOD.GET, data);
}

/**
 * #10061 新增用户
 *   POST /sys/user
 *   接口ID：216079155
 *   接口地址：https://app.apifox.com/link/project/3032888/apis/api-216079155
 * @param data
 * @return {Promise<AxiosResponse<T>>}
 */
export function addAdmin(data) {
  return request("".concat(BASE_URL) + "/sys/user", METHOD.POST, data);
}

/**
 * #10063  编辑用户
 *   PUT /sys/user/{id}
 *   接口ID：216079564
 *   接口地址：https://app.apifox.com/link/project/3032888/apis/api-216079564
 * @param data
 * @return {Promise<AxiosResponse<T>>}
 */
export function editAdmin(id, data) {
  return request("".concat(BASE_URL) + "/sys/user/".concat(id), METHOD.PUT, data);
}

/**
 * #10064 删除/启用/停用用户
 *   PUT /sys/user/status
 *   接口ID：216079589
 *   接口地址：https://app.apifox.com/link/project/3032888/apis/api-216079589
 * @param data
 * @return {Promise<AxiosResponse<T>>}
 */
export function updateAdmin(data) {
  return request("".concat(BASE_URL) + "/sys/user/status", METHOD.PUT, data);
}

/**
 * #10065  编辑用户密码
 *   PUT /sys/user/password/{id}
 *   接口ID：216110457
 *   接口地址：https://app.apifox.com/link/project/3032888/apis/api-216110457
 * @param id
 * @param data
 * @return {Promise<AxiosResponse<T>>}
 */
export function updateAdminPwd(id, data) {
  return request("".concat(BASE_URL) + "/sys/user/password/".concat(id), METHOD.PUT, data);
}